import React, { useEffect, useState, useContext } from "react";
import { registerLocales as registerLocalesForDatePickers, modalCustomStyles } from "../../../../config/Configuration";
import { Formik } from "formik";
import AuthorizationToRelease from "../sections/MedicalFacilitiesSection/AuthorizationToReleaseSection";
import InformationToRelease from "../sections/InformationToReleaseSection/InformationToReleaseSection";
import DisclosureOfSensitiveInformation from "../sections/SensitiveInfoSection/DisclosureOfSensitiveInformationSection";
import SensitiveInfoSection from "../sections/SensitiveInfoSection/SensitiveInfoSection";
import RecipientOfInfo from "../sections/RecipientOfInfoSection/RecipientOfInfoSection";
import DeliveryMethod from "../sections/DeliveryMethod_Section/DeliveryMethodSection";
import ReleaseDatesSection from "../sections/ReleaseDatesSection/ReleaseDatesSection";
import { SupportingDocsSection } from '../sections/SupportingDocsSection/SupportingDocsSection';
import { mapErrorsToSection } from "../../../../functions/mapErrorsToSection";
import { inputClasses } from "../../../../formik/refactorOut/styles";
import { hideErrorModalAction } from "../../../../context/actions/hideErrorModalAction";
import { showErrorModalAction } from "../../../../context/actions/showErrorModalAction";
import { RepContactInfoSection } from '../sections/RepContactInfoSection/RepContactInfoSection';
import { ProxyInfoSection } from '../sections/ProxyInfoSection/view';
import { ProxySupportingDocsSection } from '../sections/SupportingDocsSection/ProxySupportingDocsSection';
import { AdditionalInfoSection } from '../sections/AdditionalInfoSection/AdditionalInfoSection';
import { TempPage } from '../../../../formik/refactorOut/TempPage';
import axios from "axios";
import { SummaryModal } from '../../SummaryModal/SummaryModal';
import { spaEndpointHost, vraUX, apiHost, getwayApi } from "../../../../config/Constants";
import ErrorFocus from '../../../../formik/refactorOut/ErrorFocus'
import { TriLogoAndBanner } from '../orgs/7042/components'
import { LogoAndTitle } from '../sections/LogoAndTitle_Section/LogoAndTitle';
import { LoadingScreen } from '../../../components/LoadingScreen/LoadingScreen';
import { submitFileData, deleteFileData, submitUserData } from '../../../../functions/apiCalls';
import { orderedValues } from '../orderedValues';
import { array } from "prop-types";
import '../form.scss';
import { autofillForm } from '../../../../deleter/autofill';
import { AutoFillButton_dev } from '../../../../config/devComponents';
import { preventSubmission, setAllValuesToTouched, scrollToFirstError, addSummaryBackLogic, removeSummaryBackLogic, proceedToSummary, checkFormForErrors, assignPDFValues } from './logic';
import { assignPDFValuesML } from './logicML';
import { SummaryModal2 } from '../../SummaryModal/SummaryModal2';
import SubmissionErrorScreen from "../../SubmissionError/view";
import { CheckLanguage } from "../../../languages/languages";
import { GetLanguageText } from "../../../languages/languages";
import { SummaryModalMultiLanguage } from "../../SummaryModal/SummaryModal_MultiLanguage";
import { DisclaimersSection, ContactListSection } from "../sections/DisclaimersSection/DisclaimersSection";

registerLocalesForDatePickers();

export const ConfigContext = React.createContext();

const DynamicForm = (props) => {

    // State values
    const [nextPage, setNextPage] = useState(false);
    const [showSummary, setShowSummary] = useState(false);
    const [errorTofocus, setErrorTofocus] = useState(false);
    const [submissionError, setSubmissionError] = useState(false);
    const [localError, setLocalError] = useState(false);
    const [includeSensitiveInfo, setIncludeSensitiveInfo] = useState(false);
    const [excludeAdditionalInfoSection, setexcludeAdditionalInfoSection] = useState(false);
    const sessionId = props.session;

    // Local variables
    const { validationValues, fields, validationSchema, dbFormSpec } = props.formInfo;

    const formType = (props.formInfo.formType.indexOf('Pat') === 0) ? "Patient" : "Representative";  // This is to make it compatible with the forms listed as "Patient ES"
    const formId = props.formId;
    const proxyForm = formType === 'Representative';
    const patientForm = formType === 'Patient';
    const devMode = window.location.hostname === 'localhost';
    const logo1 = <img id='form-logo' src={`${getwayApi}/api/client/logo/${formId}`} alt={dbFormSpec.logo.alt} />
    const errorContextObject = { dbFormSpec };
    const orgId = dbFormSpec.facility.orgId
    const triPartiteOrg = orgId.includes('7042') || orgId.includes('7101') || orgId.includes('7239')
    const sensitiveInfoOrg = triPartiteOrg || orgId.includes('7152');
    const requestorIPAddress = props.formInfo.requestorIPAddress;




    // Sets the page title
    useEffect(() => {
        if (dbFormSpec.ShowSensitiveInfo === true) {
            setIncludeSensitiveInfo(true);
        }

        if (dbFormSpec.ExcludeAdditionalInfoSection) {
            setexcludeAdditionalInfoSection(true);
        }

    }, [])

    useEffect(() => {
        document.title = 'Request for Medical Records';
        // Should we also add a custom favicon for each organization? 
    }, []);

    // Adds logic so that the back button closes the summary modal, but does not go back a page.
    useEffect(() => {
        addSummaryBackLogic(setShowSummary)
        return () => { removeSummaryBackLogic(setShowSummary) }
    }, [])



    const languageID = CheckLanguage(dbFormSpec);


    if (languageID != "default") {


        const languageText = GetLanguageText(languageID);
        if (!nextPage) {
            return (
                <div id='request-form'>
                    <LogoAndTitle titleText={`${languageText.PageHeaders.pageTitle}`} formType={formType} titleColor={'#717275'} dbFormSpec={dbFormSpec} formId={props.formId} logo={logo1} formSubtype={`${languageText.PageHeaders.pageType}`} />
                    <Formik initialValues={fields} validationSchema={validationSchema} onSubmit={(values) => proceedToSummary(values, setShowSummary)} >
                        {formik => {
                            const { isValid, errors, dirty, handleSubmit } = formik;
                            const noErrors = isValid;
                            const generalContextObject = { test: 'test', dbFormSpec, formik, inputClasses, validationValues, formType, devMode: devMode, formId: props.formId, logo: logo1, showSummary: showSummary, localError, setLocalError };
                            const summaryContextObject = { formik, dbFormSpec, formId, inputClasses, validationValues, formType };
                            const requestorIPAddressRecorded = { requestorIPAddress };

                            return (
                                <form id='form-sections'
                                    onSubmit={e => {
                                        checkFormForErrors(e, noErrors, setErrorTofocus, setAllValuesToTouched, formik)
                                        Object.keys(formik.errors).length === 0 && assignPDFValuesML(formik, dbFormSpec, formType, generalContextObject, languageText, requestorIPAddress)
                                        devMode && console.log('VALUES', formik.values, 'ERRORS', formik.errors)
                                    }}
                                >

                                    {/* {devMode && <AutoFillButton_dev formik={formik}/>} */}

                                    <ConfigContext.Provider value={generalContextObject}>
                                        <RepContactInfoSection />
                                        {proxyForm && <ProxyInfoSection />}
                                        {proxyForm && <ProxySupportingDocsSection fileSubmissionAction={submitFileData(getwayApi, sessionId)} fileDeletionAction={deleteFileData(getwayApi, sessionId)} />}
                                        <InformationToRelease />
                                        {/* {dbFormSpec.facility.orgId.includes('7042') && <SensitiveInfoSection />} */}
                                        {includeSensitiveInfo && <SensitiveInfoSection />}
                                        <AuthorizationToRelease />
                                        <div id='recipient-and-delivery-sections'>
                                            <RecipientOfInfo formType={formType} />
                                            <DeliveryMethod />
                                        </div>
                                        {<SupportingDocsSection fileSubmissionAction={submitFileData(getwayApi, sessionId)} fileDeletionAction={deleteFileData(getwayApi, sessionId)} />}
                                        {!excludeAdditionalInfoSection && <AdditionalInfoSection />}

                                        <DisclaimersSection />
                                        <ContactListSection />

                                        <ReleaseDatesSection formType={formType} />


                                    </ConfigContext.Provider>


                                    {/*================================================== Summary Modal ==================================================*/}

                                    {showSummary && window.history.state &&
                                        <ConfigContext.Provider value={generalContextObject}>
                                            <SummaryModalMultiLanguage
                                                formik={formik}
                                                config={dbFormSpec}
                                                formId={props.formId}
                                                userInput={formik.values}
                                                submitData={submitUserData(apiHost, sessionId, props.esign, validationValues.context.organization, props.formId, setNextPage, setSubmissionError)}
                                                isModelOpen={true}
                                                setSummary={setShowSummary}
                                                setNextPage={setNextPage}
                                                testFormSpec={dbFormSpec}
                                                formType={formType}
                                                logo={logo1}
                                                languageText={languageText}
                                            />
                                        </ConfigContext.Provider>
                                    }

                                    {showSummary ?
                                        document.getElementsByTagName('body')[0].setAttribute('style', 'overflow: hidden')
                                        :
                                        document.getElementsByTagName('body')[0].setAttribute('style', 'overflow: scroll')
                                    }


                                    {/* <ErrorFocus {...formik} errorToFocus={errorTofocus} setErrorToFocus={setErrorTofocus}/> */}
                                </form>
                            );
                        }}
                    </Formik>
                </div>
            );
        }
        else {

            // This is not used.  
            return (
                <ConfigContext.Provider value={errorContextObject}>
                    {!submissionError.status ?
                        <LoadingScreen loadingMessage={(props.formInfo.fields.discloseToPhone === "") ? `${languageText.loadingScreens.loadingStart}` : `${languageText.loadingScreens.loadingFinalization}`} />
                        :
                        <SubmissionErrorScreen
                            errorInfo={submissionError.info}
                            orgLogo={`${getwayApi}/api/client/logo/${props.formId}`}
                            formSpec={dbFormSpec}
                            setNextPage={setNextPage}
                            setSubmissionError={setSubmissionError}
                            setShowSummary={setShowSummary} />
                    }
                </ConfigContext.Provider>
            )
            return (<LoadingScreen loadingMessage={(props.formInfo.fields.discloseToPhone === "") ? "Loading the form. We'll be just a moment." : "Finalizing your request. We'll be just a moment."} />)
        }

    } else {

        if (!nextPage) {
            return (
                <div id='request-form'>
                    <LogoAndTitle titleText={`Request for Release of Medical Information`} formType={formType} titleColor={'#717275'} dbFormSpec={dbFormSpec} formId={props.formId} logo={logo1} />

                    <Formik initialValues={fields} validationSchema={validationSchema} onSubmit={(values) => proceedToSummary(values, setShowSummary)} >
                        {formik => {
                            const { isValid, errors, dirty, handleSubmit } = formik;
                            const noErrors = isValid;
                            const generalContextObject = { test: 'test', dbFormSpec, formik, inputClasses, validationValues, formType, devMode: devMode, formId: props.formId, logo: logo1, showSummary: showSummary, localError, setLocalError }
                            const summaryContextObject = { formik, dbFormSpec, formId, inputClasses, validationValues, formType };

                            return (
                                <form id='form-sections'
                                    onSubmit={e => {
                                        checkFormForErrors(e, noErrors, setErrorTofocus, setAllValuesToTouched, formik)
                                        Object.keys(formik.errors).length === 0 && assignPDFValues(formik, dbFormSpec, formType, generalContextObject, requestorIPAddress)
                                        devMode && console.log('VALUES', formik.values, 'ERRORS', formik.errors)
                                    }}
                                >

                                    {/* {devMode && <AutoFillButton_dev formik={formik}/>} */}

                                    <ConfigContext.Provider value={generalContextObject}>
                                        <RepContactInfoSection />
                                        {proxyForm && <ProxyInfoSection />}
                                        {proxyForm && <ProxySupportingDocsSection fileSubmissionAction={submitFileData(getwayApi, sessionId)} fileDeletionAction={deleteFileData(getwayApi, sessionId)} />}
                                        <InformationToRelease />
                                        {/* {dbFormSpec.facility.orgId.includes('7042') && <SensitiveInfoSection />} */}
                                        {includeSensitiveInfo && <SensitiveInfoSection />}
                                        <AuthorizationToRelease />
                                        <div id='recipient-and-delivery-sections'>
                                            <RecipientOfInfo formType={formType} />
                                            <DeliveryMethod />
                                        </div>
                                        {<SupportingDocsSection fileSubmissionAction={submitFileData(getwayApi, sessionId)} fileDeletionAction={deleteFileData(getwayApi, sessionId)} />}
                                        {!excludeAdditionalInfoSection && <AdditionalInfoSection />}

                                        <DisclaimersSection />
                                        <ContactListSection />

                                        <ReleaseDatesSection formType={formType} />

                                    </ConfigContext.Provider>


                                    {/*================================================== Summary Modal ==================================================*/}

                                    {showSummary && window.history.state &&
                                        <ConfigContext.Provider value={generalContextObject}>
                                            <SummaryModal2
                                                formik={formik}
                                                config={dbFormSpec}
                                                formId={props.formId}
                                                userInput={formik.values}
                                                submitData={submitUserData(apiHost, sessionId, props.esign, validationValues.context.organization, props.formId, setNextPage, setSubmissionError)}
                                                isModelOpen={true}
                                                setSummary={setShowSummary}
                                                setNextPage={setNextPage}
                                                testFormSpec={dbFormSpec}
                                                formType={formType}
                                                logo={logo1}
                                                sensitiveInfoOrg={sensitiveInfoOrg}
                                            />
                                        </ConfigContext.Provider>
                                    }

                                    {showSummary ?
                                        document.getElementsByTagName('body')[0].setAttribute('style', 'overflow: hidden')
                                        :
                                        document.getElementsByTagName('body')[0].setAttribute('style', 'overflow: scroll')
                                    }


                                    {/* <ErrorFocus {...formik} errorToFocus={errorTofocus} setErrorToFocus={setErrorTofocus}/> */}
                                </form>
                            );
                        }}
                    </Formik>
                </div>
            );
        }
        else {
            // if it's loading, display the loading screen
            return (
                <ConfigContext.Provider value={errorContextObject}>
                    {!submissionError.status ?
                        <LoadingScreen loadingMessage={(props.formInfo.fields.discloseToPhone === "") ? "Loading the form. We'll be just a moment." : "Finalizing your request. We'll be just a moment."} />
                        :
                        <SubmissionErrorScreen
                            errorInfo={submissionError.info}
                            orgLogo={`${getwayApi}/api/client/logo/${props.formId}`}
                            formSpec={dbFormSpec}
                            setNextPage={setNextPage}
                            setSubmissionError={setSubmissionError}
                            setShowSummary={setShowSummary} />
                    }
                </ConfigContext.Provider>
            )
            return (<LoadingScreen loadingMessage={(props.formInfo.fields.discloseToPhone === "") ? "Loading the form. We'll be just a moment." : "Finalizing your request. We'll be just a moment."} />)
        }

    }
};


export default DynamicForm;
